import { forwardRef } from "react";

import { useHistory } from "react-router-dom";

import Box from "@/components/Box";
import Circle from "@/components/Circle";
import { CMP_LEARNING_HUB_COURSE_URL } from "@/core/urls";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";
import PaperStackIcon from "@/images/PaperStackIcon";
import Center from "@/tpo/Center";
import Group from "@/tpo/Group";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

const CourseCard = forwardRef(
  (
    { id, bg, slug, imageUrl, title, shortDescription, subtitle, backgroundColor, courseBadges },
    ref
  ) => {
    const history = useHistory();

    const { resolvedUrls } = useCmpRelatedUrl();

    return (
      <Stack
        bg={bg}
        ref={ref}
        gap={0}
        borderRadius={5}
        height="100%"
        style={{
          cursor: "pointer",
          overflow: "hidden"
        }}
        onClick={() => {
          history.push(resolvedUrls[CMP_LEARNING_HUB_COURSE_URL].replace(":slug", slug));
        }}
      >
        {imageUrl ? (
          <Box
            minHeight={300}
            style={{
              backgroundImage: `url(${imageUrl})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover"
            }}
          />
        ) : (
          <Center
            stacked
            minHeight={300}
            style={{
              backgroundColor: backgroundColor
            }}
          >
            <PaperStackIcon size={80} fill={backgroundColor === "#1A1A1A" ? "white" : "black"} />
          </Center>
        )}

        <Stack bg={bg} gap={40} padding={[20, 20, 28]} flexGrow={1} minHeight={0}>
          <Stack gap={8}>
            <Box
              fontFamily="gilroyBold"
              fontSize={[18, 18, 24]}
              sx={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
                overflow: "hidden"
              }}
            >
              {title}
            </Box>
            <Box
              fontFamily="gilroyMedium"
              fontSize={[14, 14, 16]}
              sx={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
                overflow: "hidden"
              }}
            >
              {subtitle}
            </Box>
          </Stack>
          <Group justifyContent="space-between" mt="auto">
            {!!courseBadges?.length && (
              <Group flexWrap="wrap" gap={6}>
                {courseBadges.map(cb => (
                  <Circle
                    size={52}
                    fontFamily="gilroyBold"
                    fontSize={[14, 14, 16]}
                    key={cb.id}
                    borderWidth={2}
                    backgroundColor="transparent"
                    withBorder
                    flexDirection="column"
                    gap={0}
                  >
                    <Box fontSize={12} lineHeight="100%" textTransform="uppercase">
                      {cb.badge.name}
                    </Box>
                    <Box fontSize={24} lineHeight="100%">
                      {cb.points}
                    </Box>
                  </Circle>
                ))}
              </Group>
            )}
            <ButtonV2 color="dark" size="xs" sx={{ mt: "auto" }}>
              learn more
            </ButtonV2>
          </Group>
        </Stack>
      </Stack>
    );
  }
);

CourseCard.defaultProps = {
  bg: "white"
};

export default CourseCard;
